import React, { useEffect, useState } from "react";
import api, { formatApiError } from "../../lib/api";
import { Window, Dialog, ConfirmDialog, EmptyState, Loading } from "../../components/VB";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";

export default function AturShift() {
  const [items, setItems] = useState([]);
  const [emps, setEmps] = useState([]);
  const [shifts, setShifts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const today = new Date().toISOString().slice(0, 10);
  const [form, setForm] = useState({ employee_id: "", shift_id: "", tanggal_mulai: today, tanggal_selesai: "", status_aktif: true });
  const [del, setDel] = useState(null);

  const load = async () => {
    setLoading(true);
    try {
      const [a, e, s] = await Promise.all([api.get("/shift-assignments"), api.get("/employees"), api.get("/shifts")]);
      setItems(a.data); setEmps(e.data); setShifts(s.data);
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/shift-assignments", form);
      toast.success("Assignment tersimpan");
      setOpen(false); load();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };
  const doDelete = async () => {
    try { await api.delete(`/shift-assignments/${del.id}`); toast.success("Dihapus"); setDel(null); load(); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };
  const empName = (id) => emps.find((e) => e.id === id)?.nama_lengkap || "-";
  const shiftName = (id) => shifts.find((e) => e.id === id)?.nama || "-";

  return (
    <Window
      title="Atur Shift Karyawan"
      actions={<button className="vb-btn" onClick={() => setOpen(true)} data-testid="add-shiftassign"><Plus className="w-3 h-3 inline mr-1" />Tambah</button>}
    >
      {loading ? <Loading /> : items.length === 0 ? <EmptyState /> : (
        <table className="vb-table">
          <thead><tr><th>Karyawan</th><th>Shift</th><th>Mulai</th><th>Selesai</th><th>Status</th><th>Aksi</th></tr></thead>
          <tbody>
            {items.map((it) => (
              <tr key={it.id}>
                <td>{empName(it.employee_id)}</td><td>{shiftName(it.shift_id)}</td>
                <td>{it.tanggal_mulai}</td><td>{it.tanggal_selesai || "-"}</td>
                <td>{it.status_aktif ? "Aktif" : "Nonaktif"}</td>
                <td><button className="vb-btn-danger" style={{ padding: "2px 6px" }} onClick={() => setDel(it)} data-testid={`sa-del-${it.id}`}><Trash2 className="w-3 h-3" /></button></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      <Dialog open={open} onClose={() => setOpen(false)} title="Atur Shift Karyawan"
        footer={<><button className="vb-btn" onClick={() => setOpen(false)}>Batal</button><button className="vb-btn-primary" onClick={submit} data-testid="sa-save">Simpan</button></>}>
        <form onSubmit={submit}>
          <div className="vb-form-row"><label className="vb-label">Karyawan*</label>
            <select className="vb-select" value={form.employee_id} onChange={(e) => setForm({ ...form, employee_id: e.target.value })} required data-testid="sa-emp">
              <option value="">- pilih -</option>
              {emps.map((e) => <option key={e.id} value={e.id}>{e.nama_lengkap}</option>)}
            </select></div>
          <div className="vb-form-row"><label className="vb-label">Shift*</label>
            <select className="vb-select" value={form.shift_id} onChange={(e) => setForm({ ...form, shift_id: e.target.value })} required data-testid="sa-shift">
              <option value="">- pilih -</option>
              {shifts.map((s) => <option key={s.id} value={s.id}>{s.nama}</option>)}
            </select></div>
          <div className="vb-form-row"><label className="vb-label">Tanggal Mulai*</label>
            <input type="date" className="vb-input" value={form.tanggal_mulai} onChange={(e) => setForm({ ...form, tanggal_mulai: e.target.value })} required data-testid="sa-mulai" /></div>
          <div className="vb-form-row"><label className="vb-label">Tanggal Selesai</label>
            <input type="date" className="vb-input" value={form.tanggal_selesai} onChange={(e) => setForm({ ...form, tanggal_selesai: e.target.value })} data-testid="sa-selesai" /></div>
          <label style={{ fontSize: 13 }}><input type="checkbox" checked={form.status_aktif} onChange={(e) => setForm({ ...form, status_aktif: e.target.checked })} /> Aktif</label>
        </form>
      </Dialog>

      <ConfirmDialog open={!!del} onClose={() => setDel(null)} onConfirm={doDelete} message="Yakin hapus shift assignment?" />
    </Window>
  );
}
